import logSearchPageFilter from "lib/ga/searchPageFilter";
import logEvent from "lib/ga/miscEvent";
import styles from './toolbar.module.css';

type PageProps = {
  filters: any,
  setFilter: any,
  removeFilter: any,
  sizeTypes: any,
  setSizeMeasurementType: any,
  sizeValue: string
};

const SizeFiliterType = ({ sizeTypes, setSizeMeasurementType, removeFilter, filters, sizeValue }: PageProps) => {

  const googleEvents = (location, value, filterLabel) => {
    logEvent({
      category: "Flexible Search",
      action: "Filter Applied",
      label: `Location: ${location}, Filter: ${filterLabel}, Value: ${JSON.stringify(value)}`,
    });

    logSearchPageFilter({
      filter: filterLabel,
      value: JSON.stringify(value),
      state: "add",
    });
  }

  const changeSizeMeasurement = (value) => {
    let allReadySet = filters.filter(function (e) { return e.values[0].name === 'size'; });
    if (allReadySet.length > 0) {
        removeFilter(allReadySet[0].field);
        setSizeMeasurementType(value);
        googleEvents(location, value, 'size_type');
    } else {
      setSizeMeasurementType(value)
      googleEvents(location, value, 'size_type');
    }

  }

 const defaultSize = sizeTypes[0].value === sizeValue ? 0 : 1;

  return (
 
      <div className={styles.selectSizeType}> 
        {sizeTypes.map((size, index) => (
        <div className={styles.radioContainer} key={`size-${index}`}> 
          <input type="radio"  id={`size-${index}`} checked={index === defaultSize} value={index} onChange={(e) => {
            changeSizeMeasurement(sizeTypes[e.target.value]);
          }} />
          <label htmlFor={`size-${index}`}>{size.name}</label>
        </div>
       ))}
   
  </div>
  )

}

export default SizeFiliterType;